import { ActivityFieldHydration } from '../../../shared/modules/activity/dtos/activity-field-hydration.dto';
import { ActivityLinkHydration } from '../../../shared/modules/activity/dtos/activity-link-hydration.dto';
import { AgentSearchDto } from '../../agents';
import { LocationSearchDto } from '../../locations';
import { VehicleCategorySearchDto } from '../../vehicle-categories';
import { VehicleSearchDto } from '../../vehicles';

/**
 * Resolved related records for a rental reservation activity event, keyed by relation.
 */
export class RentalReservationActivityEventHydration {
  vehicle?: ActivityFieldHydration<VehicleSearchDto>;
  vehicleCategory?: ActivityFieldHydration<VehicleCategorySearchDto>;
  pickupLocation?: ActivityFieldHydration<LocationSearchDto>;
  dropOffLocation?: ActivityFieldHydration<LocationSearchDto>;
  agent?: ActivityFieldHydration<AgentSearchDto>;
  link?: ActivityLinkHydration;
}
